import { SelectOption } from "../../../Widgets/LabeledSelect";

export type { AreaOfConcernEntry } from "hooks/api/client/useGetAreasOfConcern";

export const SAFETY_CONCERNS_OPTIONS: SelectOption[] = [
  { value: "AGGRESSIVE_BEHAVIOR", label: "Aggressive Behavior" },
  { value: "SELF_INJURY", label: "Self-Injurious Behavior" },
  { value: "ELOPEMENT_NOT_MANAGEABLE", label: "Elopement not Manageable by 1 Adult" },
  { value: "CURRENT_SUBSTANCE_ABUSE", label: "Current Substance Abuse" },
  { value: "PSYCHIATRIC_INPATIENT_LAST_YEAR", label: "Psychiatric Inpatient in the Last Year" },
  { value: "ARREST_OR_LAW_ENFORCEMENT", label: "Arrest or Other Involvement with Law Enforcement in the Last Year" },
  { value: "SEXUAL_OFFENSES_OR_ABUSE", label: "Sexual Offenses or Sexual Abuse" },
  { value: "CURRENT_FAMILY_VIOLENCE", label: "Current Family Violence" },
  { value: "SUICIDAL_THOUGHTS", label: "Suicidal Thoughts" },
  { value: "HOMICIDAL_THOUGHTS", label: "Homicidal Thoughts" },
  { value: "FIRE_SETTING", label: "Fire Setting" },
  { value: "SELF_MUTILATION_CUTTING", label: "Self-Mutilation/ Cutting" },
];

export const CONCERN_CATEGORIES_CONFIG = {
  adaptiveBehavior: { label: "Adaptive Behavior", enumValue: "ADAPTIVE_BEHAVIOR" },
  communication: { label: "Communication", enumValue: "COMMUNICATION" },
  communityParticipation: {
    label: "Community Participation",
    enumValue: "COMMUNITY_PARTICIPATION",
  },
  executiveFunctioning: { label: "Executive Functioning", enumValue: "EXECUTIVE_FUNCTIONING" },
  socialEmotional: { label: "Social/Emotional", enumValue: "SOCIAL_EMOTIONAL" },
  challengingBehaviors: { label: "Challenging Behaviors", enumValue: "CHALLENGING_BEHAVIORS" },
} as const;

export type ConcernCategoryKey = keyof typeof CONCERN_CATEGORIES_CONFIG;

export const ENUM_TO_CATEGORY: Record<string, ConcernCategoryKey> = {
  ADAPTIVE_BEHAVIOR: "adaptiveBehavior",
  COMMUNICATION: "communication",
  COMMUNITY_PARTICIPATION: "communityParticipation",
  EXECUTIVE_FUNCTIONING: "executiveFunctioning",
  SOCIAL_EMOTIONAL: "socialEmotional",
  CHALLENGING_BEHAVIORS: "challengingBehaviors",
};
